export default "__VITE_ASSET__C0bw2B4L__"